
















































































































































































































































































































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutoCompleteAddress from '@/components/UI/autocomplete-address.vue';
import UiAutocompleteSubordinate from '@/components/UI/autocomplete-subordinate.vue';
import UiAutocompleteUF from '@/components/UI/autocomplete-uf.vue';
import UiCepTextField from '@/components/UI/cep-textfield.vue';
import UiComboboxIndividual from '@/components/UI/combobox-individual.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiTimePicker from '@/components/UI/time-picker.vue';
import { ConflitoAgendaFiltros } from '@/interfaces/calendar';
import { RegistroVisitaParmDTO } from '@/interfaces/crm-visit';
import * as service from '@/services/crm-visit';
import { getLocalUser } from '@/services/session-data';
import { getServerISODate } from '@/services/utils';
import * as resize from '@/subjects/resize';
import moment from 'moment';
import { Observable } from 'rxjs';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import CalendarConflictAlertDialog from '../calendar/calendar-conflict-alert-dialog.vue';
import ContactRelationshipTable from '../contact/contact-relationship-table.vue';
import UiSelectInstitution from '../institution/select-institution.vue';
import VisitPlanningCycle from '../visit-planning/visit-planning-cycle.vue';

@Component({
  components: {
    UiSelectInstitution,
    UiDatePicker,
    UiComboboxIndividual,
    UiCepTextField,
    ContactRelationshipTable,
    UiAutocompleteSubordinate,
    UiTimePicker,
    UiAutocompleteUF,
    UiAutoCompleteAddress,
    VisitPlanningCycle,
    CalendarConflictAlertDialog
  }
})
export default class VisitForm extends BaseComponent {  
  @Prop()
  id: number;

  @Prop()
  idInstitution: number;

  @Prop()
  date: string;

  @Prop({ default: false })
  edit: boolean;

  modalOpen = false;

  dto: any = { data: null, presencial: null };
  endereco: any = {};
  contatos: any = [];
  chkEnderecoGoogle = false;
  enderecoGoogle = null;

  currentTab = 'tab-dados-base';

  smallScreen: boolean = resize.isXsOrSmSizeScreen();

  minDateVisit = null;
  maxDateVisit = null;
  dateHint = null;

  minDateProxVisit = null;

  cycle = null;
  returnDateHint = null;

  agendamentosLoading = false;
  agendamentos = [];
  agendamento = null;

  ID_AGENDAMENTO_SEM_AGEND = -1;
  urgente = false;
  showCycle = false;

  conflictParms: ConflitoAgendaFiltros = null;
  formConflictOpened = false;

  public form: any = {
    valid: false,
    rules: {
      data: [(v) => this.validVisitDate(v)],
      horario: [(v) => (!!v && v.length == 5) || 'Informe um horário válido'],
      horaFimVisita: [(v) => (!!v && v.length == 5) || 'Informe um horário válido'],
      instituicao: [(v) => !!v || 'Selecione a Instituição'],
      agendamento: [(v) => !!v || 'Selecione o Agendamento'],
      presencial: [(v) => v != null || 'Selecione a Modalidade'],
      logradouro: [(v) => !!v || 'Informe o logradouro'],
      numero: [(v) => !!v || 'Informe o número'],
      bairro: [(v) => !!v || 'Informe o bairro'],
      cidade: [(v) => !!v || 'Informe a cidade'],
      estado: [(v) => !!v || 'Informe o estado'],
      cep: [(v) => !!v || 'Informe o CEP'],
      visitantes: [(v) => (!!v && v.length > 0) || 'Selecione pelo menos um Consultor'],
      contatos: [(v) => (!!v && v.length > 0) || 'Selecione pelo menos um Contato'],
      objetivo: [(v) => (!!v && v.length > 4) || 'Informe o Objetivo'],
      objetivoCumprido: [(v) => v != null || 'Selecione Sim ou Não'],
      visitaAtendida: [(v) => v != null || 'Selecione Sim ou Não'],
      detalhesVisita: [(v) => (!!v && v.length > 3) || 'Descreva os detalhes da visita']
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    if (this.id == null) {
      setTimeout(() => {
        this.modalOpen = true;
      }, 50);
      getLocalUser().subscribe((res) => {
        this.dto.idsVisitantes = [res.idLogin];
      });
    }
    resize.windowSizeChanged$.subscribe((res) => {
      this.smallScreen = resize.isXsOrSmSizeScreen();
    });
    getServerISODate().subscribe((res) => {
      this.minDateProxVisit = res;
      this.maxDateVisit = res;
    });
  }

  @Watch('id', { immediate: true })
  onIdChange(id) {
    if (!id) {
      return;
    }

    this.loader.start('Carregando ...');
    service.getCrmVisitDetails(id).subscribe(
      (res) => {
        this.dto = { ...res };
        this.urgente = false;
        this.endereco = this.dto.endereco;
        if (!this.endereco) {
          this.endereco = {};
        }
        this.contatos = this.dto.contatos;
        this.modalOpen = true;
        this.loader.stop();
        if (this.dto.idAgendamento == null) {
          this.dto.idAgendamento = this.ID_AGENDAMENTO_SEM_AGEND;
        } else {
          this.loadVisitPlanningDetails();
        }
        this.loadVisitsPlanning();
      },
      (error) => {
        this.showToastApiError(error);
        this.close();
        this.loader.stop();
      }
    );
  }

  @Watch('idInstitution', { immediate: true })
  onIdInstitutionChange(id) {
    this.dto.idInstituicao = id;
    this.onInstitutionChange();
  }

  @Watch('date', { immediate: true })
  onDateChange(date) {
    this.dto.data = date;
  }

  public close(): void {
    this.$emit('close');
  }

  public save() {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }
    let parm: RegistroVisitaParmDTO = this.prepareParms();

    let obs: Observable<any> = null;
    if (this.dto.id) {
      parm.id = this.dto.id;
      obs = service.updateCrmVisit(parm);
    } else {
      obs = service.saveCrmVisit(parm);
    }
    this.loader.start('Processando ...');
    obs.subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show('Registro salvo com sucesso', 'success');
        this.$emit('afterSave', res);
      },
      (error) => {
        this.showToastApiError(error);
        this.loader.stop();
      }
    );
  }

  prepareParms() {
    let parm: RegistroVisitaParmDTO = Object.assign(new RegistroVisitaParmDTO(), this.dto);
    if (parm.presencial) {
      parm.endereco = this.endereco;
    } else {
      parm.endereco = null;
    }
    if (this.contatos) {
      let contatos: any = Array.from(this.contatos);
      parm.idsContatos = contatos.map((c) => c.id);
    }
    if (parm.idAgendamento == this.ID_AGENDAMENTO_SEM_AGEND) {
      parm.idAgendamento = null;
    }
    return parm;
  }

  preSave() {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    let parm = this.prepareParms();

    this.conflictParms = new ConflitoAgendaFiltros();
    this.conflictParms.tipoAlterando = 'RV';
    this.conflictParms.idAlterando = this.dto.id;
    this.conflictParms.dataIni = parm.data;
    this.conflictParms.dataFim = parm.data;
    this.conflictParms.horaIni = parm.horario;
    this.conflictParms.horaFim = parm.horaFimVisita;
    this.conflictParms.idsLogins = parm.idsVisitantes;
    this.conflictParms.idInstituicao = parm.idInstituicao;

    this.formConflictOpened = true;      
  }

  onReturnSave() {
    this.formConflictOpened = false;
    this.save();
  }

  onReturnCancel() {
    this.formConflictOpened = false;
  }

  onCepResult(end) {
    if (!end) {
      return;
    }
    this.endereco = { ...this.endereco, ...end };
  }

  onInstitutionChange() {
    this.dto.idAgendamento = null;
    if (!this.dto.idInstituicao) {
      return;
    }
    this.loadVisitsPlanning();
  }

  loadVisitsPlanning() {
    this.agendamentosLoading = true;
    service.listCrmVisitPlanning(this.dto.idInstituicao).subscribe(
      (res) => {
        this.agendamentos = res;
        this.agendamentos.unshift({ id: this.ID_AGENDAMENTO_SEM_AGEND, nome: 'Não planejada' });
        this.agendamentosLoading = false;
        if (
          this.dto.idAgendamento &&
          this.dto.idAgendamento > 0 &&
          this.agendamentos.findIndex((a) => a.id == this.dto.idAgendamento) == -1
        ) {
          this.agendamentos.push({ id: this.dto.idAgendamento, nome: this.dto.dsAgendamento });
        }
      },
      (error) => {
        this.showToastApiError(error);
        this.agendamentosLoading = false;
      }
    );
  }

  loadInstitutionDetails() {
    if (!this.dto.idInstituicao) {
      return;
    }

    service.getCrmVisitInstitution(this.dto.idInstituicao).subscribe(
      (res) => {
        this.endereco = res.endereco;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  onModalityChange() {
    this.loadInstitutionDetails();
  }

  onVisitPlanningChange() {
    if (!this.dto.idAgendamento) {
      return;
    }
    if (this.dto.idAgendamento == this.ID_AGENDAMENTO_SEM_AGEND) {
      this.agendamento = null;
      this.loadInstitutionDetails();
      if (this.dto.objetivo) this.dto.objetivo = null;
      if (this.dto.observacao) this.dto.observacao = null;
      //if (this.dto.data) this.dto.data = null;
      if (this.dto.horario) this.dto.horario = null;
    } else {
      this.loadVisitPlanningDetails();
    }
  }

  loadVisitPlanningDetails() {
    if (!this.dto.idAgendamento || this.dto.idAgendamento < 1) {
      return;
    }
    this.loader.start('Processando ...');
    service.getCrmVisitPlanningDetails(this.dto.idAgendamento).subscribe(
      (res) => {
        this.loader.stop();
        this.agendamento = res;
        if (this.id == null) {
          this.dto.presencial = res.presencial;
          Object.keys(res).forEach((prop) => {
            if (prop != 'id' && res[prop]) {
              this.dto[prop] = res[prop];
            }
          });

          this.endereco = res.endereco;
          this.contatos = res.contatos;
        }
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }

  @Watch('enderecoGoogle')
  onEnderecoGoogleChange(e) {
    if (!e) {
      return;
    }
    this.endereco = e;
  }

  onCycleLoaded(cycle) {
    if (cycle == null) {
      this.close();
    }
    this.cycle = cycle;
    this.minDateVisit = this.cycle.dataLimiteLancVisita;
    this.dateHint = `O ciclo de planejamento atual permite registrar visita realizada a partir de ${this.cycle.dataLimiteLancVisitaFmt}.`;
  }

  onDataPrevProxVisitaChange() {
    if (!this.cycle) {
      return;
    }
    this.urgente = false;
    this.returnDateHint = null;
    let d = this.dto.dataPrevProxVisita;
    if (!moment(this.cycle.dataMinPermitida, 'YYYY-MM-DD').isAfter(moment(d, 'YYYY-MM-DD'))) {
      this.returnDateHint = null;
      return;
    }
    this.showCycle = true;
    this.returnDateHint = `O ciclo de planejamento atual permite agendamento com data a partir de ${
      this.cycle.dataMinPermitidaFmt
    }. Com a data escolhida (${this.dateFormatHelper(d, 'BR')}) será gerado um agendamento com prioridade URGENTE`;
    if (this.urgente) {
      return;
    }
    let msg = `O ciclo de planejamento está fechado para a próxima visita prevista. Por isso, o sistema classificará automaticamente a visita como <strong>Urgente</strong>.`;
    msg += `<br>Deseja manter o agendamento como <strong>Urgente</strong> ou alterá-lo para <strong>Ciclo aberto</strong>?`;
    this.dialog.show(
      'alert',
      'Ciclo de Planejamento Encerrado',
      null,
      'Manter Urgente',
      () => {
        this.urgente = true;
      },
      'Ciclo aberto',
      () => {
        this.urgente = false;
        this.dto.dataPrevProxVisita = null;
        this.$refs['dataPrevProxVisita'].focus();
      },
      msg,
      '500px'
    );
  }

  validVisitDate(v) {
    if (!v) {
      return 'Informe uma data válida';
    }
    let d = moment(this.dto.data, 'YYYY-MM-DD');
    if (!!this.cycle && !!this.cycle.dataLimiteLancVisita && d.isBefore(moment(this.cycle.dataLimiteLancVisita))) {
      return this.dateHint;
    }
    if (d.isAfter(moment(this.maxDateVisit))) {
      return `Data máxima permitida: ${this.dateFormatHelper(this.maxDateVisit, 'BR')}`;
    }
    return true;
  }

  functionEventsColors(date) {
    if (!this.cycle || !this.cycle.dataMinPermitida) {
      return [];
    }
    let d = moment(date, 'YYYY-MM-DD');
    if (d.isBefore(moment(this.minDateProxVisit, 'YYYY-MM-DD'))) {
      return [];
    }
    if (d.isBefore(moment(this.cycle.dataMinPermitida, 'YYYY-MM-DD'))) {
      return ['orange'];
    } else if (!d.isAfter(moment(this.cycle.dataFim, 'YYYY-MM-DD'))) {
      return ['green'];
    }
    return [];
  }
}
